module.exports = __webpack_public_path__ + "media/images/receive_mail-921b671df92f64a82abe7e8e54401772.svg";